module.exports = __webpack_public_path__ + "static/media/delete_white.06737397.svg";